<template>
  <div>
    <div v-if="visitorState === 'pending'">
      Pending your verification
    </div>
    <div v-else-if="visitorState === 'existing' && userState === 'notauth'">
      Experience the power of discernment
      <button @click.prevent="login">Login</button>
    </div>
    <div
      class="topNav"
      v-else-if="visitorState === 'existing' && userState === 'auth'"
    >
      <div class="alignLeft"><Menu :size="48" /></div>
      <div class="app-header">
        Experience the power of discernment
      </div>
      <div class="alignRight">
        <button @click.prevent="logout">Sign Out</button>
      </div>
    </div>
    <div v-else-if="visitorState === 'reset' && userState === 'notauth'">
      Experience the power of discernment
      <button @click.prevent="reset">Reset</button>
    </div>
    <div v-else>
      Experience the power of discernment
      <button @click.prevent="signup">Sign Up</button>
      <button @click.prevent="login">Login</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Menu from "vue-material-design-icons/Menu.vue";
export default {
  name: "appheader",
  components: {
    Menu
  },
  data() {
    return {
      showLogin: false,
      showSignup: false,
      showReset: false
    };
  },
  mounted() {
    // let userStatus = this.$cookies.get("dw_id");
    // let userAuth = this.$cookies.get("authStatus");
    // console.log(userStatus, userAuth);
  },
  computed: {
    ...mapGetters([
      "getVisitorStatus",
      "getLoginForm",
      "getSigninForm",
      "getResetForm",
      "getUserStatus",
      "getVisitorAuth"
    ]),
    visitorState() {
      let status = null;
      let userAuth = null;
      let known = null;
      this.updateVisitorStatus("new");
      // console.log(this.$cookies.get('initial'));
      // debugger;
      if (this.$cookies.get("dw_id") === undefined) {
        status = this.$cookies.get("initial");
      } else {
        status = this.$cookies.get("dw_id");
      }
      if (
        (this.$cookies.get("authStatus") === undefined) |
        (this.$cookies.get("authStatus") === null)
      ) {
        userAuth = "notauth";
      } else {
        userAuth = this.$cookies.get("authStatus");
      }

      if (status === null) {
        this.$cookies.set("initial", "new");
        // console.log('if true: this.$cookies is: ',this.$cookies.get("initial"), userAuth);
        this.updateVisitorStatus("new");
        this.updateUserStatus(userAuth);
      } else if (status === "pending") {
        this.updateVisitorStatus(status);
      } else {
        // console.log('if false: this.$cookies is: ',this.$cookies.get("dw_id"));
        if ((status.length < 12) & (status !== "reset")) {
          //cookie is not from the server and not new
          // console.log("BAD COOKIE");
        }
        if (status.length > 12) {
          known = "existing";
        } else {
          known = status;
        }
        // console.log("last else in statement: ", userAuth, known);
        this.updateVisitorStatus(known);
        this.updateUserStatus(userAuth);
      }
      // console.log(this.getVisitorStatus, "VISITOR STATUS");
      return this.getVisitorStatus;
    },
    userState() {
      // console.log(this.getUserStatus, "USER_STATUS");
      return this.getUserStatus;
    }
  },
  methods: {
    ...mapActions([
      "updateVisitorStatus",
      "showLoginForm",
      "showResetForm",
      "showSigninForm",
      "updateUserStatus",
      "updateVisitorAuth",
      "sessionStatus"
    ]),
    logout() {
      let signout = {
        sessionid: this.$cookies.get("session"),
        started: this.$cookies.get("started")
      };
      this.sessionStatus(signout);
      this.$cookies.set("session", "");
      this.$cookies.set("authStatus", "notauth");
      this.updateVisitorAuth("notauth");
      this.$nextTick(() => this.userState);
      location.reload();
    },
    login() {
      this.showLogin = this.getLoginForm;
      if (this.showLogin) {
        this.showLogin = false;
        this.showLoginForm(this.showLogin);
      } else {
        this.showLogin = true;
        this.showLoginForm(this.showLogin);
      }
      // console.log(this.showLogin);
    },
    signup() {
      this.showSignup = this.getSigininForm;
      if (this.showSignup) {
        this.showSignup = false;
        this.showSigninForm(this.showSignup);
        this.$nextTick(() => this.userState);
      } else {
        this.showSignup = true;
        this.showSigninForm(this.showSignup);
        this.$nextTick(() => this.showModalSignUp);
      }
      // console.log(this.showSignup, "SIGNUP");
    },
    reset() {
      this.showReset = this.getResetForm;
      if (this.showReset) {
        this.showReset = false;
        this.showResetForm(this.showReset);
        this.$nextTick(() => this.userState);
      } else {
        this.showReset = true;
        this.showResetForm(this.showReset);
        // this.$nextTick(() => this.showModalSignUp);
      }
      // console.log(this.showSignup, "SIGNUP");
    }
  }
};
</script>

<style scoped>
.topNav {
  display: grid;
  border: 1px solid silver;
  margin: 5px;
  padding: 5px;
  grid-template-columns: 1fr 4fr 1fr;
  grid-template-rows: none;
  grid-template-areas: "nav header auth";
}
.app-header {
  grid-area: header;
  border: solid tan 1px;
  align-content: center;
}
.alignLeft {
  border: 1px solid orange;
  grid-area: nav;
  /* justify-self: start; */
}
.alignRight {
  border: 1px solid red;
  grid-area: auth;
}
</style>
